<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="1200px"
    class="historical-failure"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>故障信息详情</span>
    </div>
    <el-table
      height="400px"
      :data="tableData"
      border
      stripe
      row-key="index"
      size="mini"
    >
      <el-table-column
        v-for="(item,index) in tableColumns"
        :key="index"
        :label="item.label"
        minWidth="140"
        :prop="item.key"
        align="center"
        v-slot="{ row }"
      >
        <span v-if="item.key === 'soc'">{{ useValue(row[item.key]) }}%</span>
        <span v-else>{{ row[item.key] }}</span>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { historicalFailure } from '@/assets/js/registerType.js';
export default {
  name:'HistoricalFailure',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    terminalNo: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      tableData:[],
      tableColumns:historicalFailure[1].children
    };
  },
  watch:{
    visible:{
      handler(val){
        val && this.getData();
      },
      deep:true,
    }
  },
  methods: {
    useValue(value){
      if(!value) return 0;
      return value * 100
    },
    // 获取数据
    async getData(){
      try{
        const { data, code, msg } = await this.$API.queryHistoricalFaultInformation({ terminalNo:this.terminalNo });
        if(code !== 0) throw { msg };
        if(data){
          this.tableData = data.map(item => ({ ...item.historicalFaultDetail }));
        }else{
          this.tableData = [];
        }
        console.log(this.tableData,'this.dataInfo');
      }catch({ msg }) {
        this.$msg({
          type:'error',
          message:msg
        })
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.historical-failure{
  ::v-deep .el-dialog__body {
    padding: 20px 0 10px !important;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 12px !important;
  }
  .w__100{
    width: 100%;
  }
  .Diatitle {
    width: 100%;
    height: 42px;
    background-color: #f6f6f6;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    span {
      padding: 0 20px;
      font-size: 18px;
      font-family: 'PingFang SC';
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }
}

</style>
